package one.healthium.onboarding.ui.screens

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.imePadding
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.ui.text.input.KeyboardCapitalization
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import one.healthium.onboarding.domain.configs.NameInputScreenConfig
import one.healthium.onboarding.ui.UserDataProvider
import one.healthium.onboarding.ui.UserProfileUiModel
import one.healthium.onboarding.ui.bindPlaceholderValues
import one.healthium.ui.components.CtaButton
import one.healthium.ui.compose.components.AppScaffold
import one.healthium.ui.compose.components.AppText
import one.healthium.ui.compose.components.AppTextField
import one.healthium.ui.compose.theme.AppTheme

interface NameInputEventDelegate {
    fun onNextClicked()
}

@Composable
internal fun NameInputScreen(
    screenConfig: NameInputScreenConfig,
    eventDelegate: NameInputEventDelegate
) {
    UserDataProvider { userState, contract ->
        AppScaffold {
            NameInputScreenContent(
                screenConfig = screenConfig,
                userState = userState,
                onNameChanged = contract::onNameChanged,
                onNextClicked = eventDelegate::onNextClicked,
            )
        }
    }
}

@Composable
internal fun NameInputScreenContent(
    modifier: Modifier = Modifier,
    screenConfig: NameInputScreenConfig,
    userState: UserProfileUiModel,
    onNameChanged: (String) -> Unit,
    onNextClicked: () -> Unit,
) {
    Column(
        modifier = modifier
            .fillMaxSize()
            .statusBarsPadding()
            .navigationBarsPadding()
            .padding(horizontal = 24.dp),
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        AppText(
            text = screenConfig.title?.bindPlaceholderValues(userState),
            style = AppTheme.textStyles.header,
            color = AppTheme.colors.text100,
            textAlign = TextAlign.Center,
        )
        Spacer(Modifier.height(24.dp))
        Spacer(Modifier.weight(1f))
        AppTextField(
            modifier = Modifier.fillMaxWidth(),
            value = userState.name ?: "",
            onValueChange = onNameChanged,
            textStyle = AppTheme.textStyles.textField.copy(textAlign = TextAlign.Center),
            keyboardOptions = KeyboardOptions(
                capitalization = KeyboardCapitalization.Words,
                imeAction = ImeAction.Done,
            ),
            showKeyboardAutomaticallyIfEmpty = true,
            maxLines = 1,
        )
        Spacer(Modifier.weight(1f))
        Spacer(Modifier.height(24.dp))
        AppText(
            text = screenConfig.hint?.bindPlaceholderValues(userState),
            style = AppTheme.textStyles.subTitle,
            color = AppTheme.colors.text400,
            textAlign = TextAlign.Center,
        )
        Spacer(Modifier.height(37.dp))
        CtaButton(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = 14.dp),
            text = screenConfig.ctaTitle,
            enabled = userState.name.isNullOrBlank().not(),
            onClick = onNextClicked,
        )
        Spacer(Modifier.height(24.dp))
        Spacer(Modifier.navigationBarsPadding().imePadding())
    }
}
